module.exports = __webpack_public_path__ + "img/icon_3_1.2b8057ed.png";